<script>
    import { Modal } from '../static/bootstrap.js';

    /* import galleryImages from '../static/gallery'; */
    import galleryGroup from '../static/galleryPageGrouping';

    import Image from '../elements/image.svelte';

    /* let sortedGalleryImages = [];
    galleryImages.forEach((image, index) => {
        sortedGalleryImages.push({
            path: image,
            id: image.replaceAll(' ', ''),
        });
    }); */
</script>

<svelte:head>
	<title>illustrations - wangsichun studio</title>
</svelte:head>

<div class="illus-wrapper" id="illustrations">
    <div class="page-image"></div>
    <div class="page-content">
        
        <div class="container">
            <h1 class="font-VarelaRound">illustrations</h1>
        </div>

        <div class="container">
            <div class="row">
                {#each Object.entries(galleryGroup).reverse() as [title, images]}
                <div class="col-md-6 my-4">
                    <h5 class="font-VarelaRound">{title}</h5>

                    {#each images as image}
                    <div class="my-3">
                        <div style="width:70%;" class="mx-auto">
                            <Image
                                src="build/assets/img/gallery_details/{image}"
                                eleclass="img-fluid img-thumbnail bg-transparent"
                                on:click={() => new Modal(document.getElementById(image.replaceAll(' ', ''))).toggle()} />
                        </div>
    
                        <div class="modal fade" id={image.replaceAll(' ', '')}>
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <Image src="build/assets/img/gallery_details/{image}" style="max-width:100%;" />
                            </div>
                        </div>
                    </div>
                    {/each}
                </div>
	            {/each}
            </div>
        </div>

    </div>
</div>

<style lang="scss">
	@import "src/scss/illustrations";
</style>